export class RateLocationType {
  static OriginLocation = 0;
  static DestinationLocation = 1;
}
